import { registerStitchInLibrary } from "./registerStitchInLibrary";

/**
 * @param {import("../../../context/GlobalContext").GlobalContextValue["hitAxios"]} hitAxios
 * @param {{
 *   clips: { url: string, duration: number }[],
 *   output_filename: string,
 *   output_resolution: string,
 * }} payload
 */
export async function stitchVideoClips(hitAxios, payload) {
  const res = await hitAxios({
    path: "/api/video/stitch",
    post: true,
    obj: payload,
    showLoading: false,
    showSnackbar: false,
    timeout: 600000,
  });

  if (!res?.data?.success) {
    const msg = res?.data?.msg || res?.error || "Stitching failed.";
    throw new Error(msg);
  }

  const data = res.data.data || {};

  if (!data.job_id && data.output_url) {
    try {
      const lib = await registerStitchInLibrary(hitAxios, {
        output_url: data.output_url,
        stored: data.stored || data.output_url,
        output_filename: data.output_filename,
        total_duration: data.total_duration,
        output_resolution: payload.output_resolution,
        clip_count: payload.clips?.length,
      });
      if (lib?.job_id) {
        data.job_id = lib.job_id;
        data.library_job = lib.job;
      }
    } catch {
      data.library_warning =
        data.library_warning || "Video joined but could not be added to your library.";
    }
  }

  return data;
}
